<p-stepper [formGroup]="orderForm" [orientation]="'horizontal'" linear="true">

    <p-stepperPanel [header]="'WAREHOUSE.WAREHOUSEORDRE.STOCK' | translate">
        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-index="index">

            <div style="display: flex; flex-direction: row; justify-content: space-between;">
                <div style="display: flex; flex-direction: column;" *ngIf="!IsShowSelectedItems; else placeholderText">
                    <!-- <label for="catalogItem">Vælg vare fra katalog</label> -->
                    <div style="display: flex; flex-direction: row; gap:12px">
                        <p-autoComplete
                                        formControlName="catalogItem"
                                        [suggestions]="filteredItemStocks"
                                        optionLabel="itemName"
                                        placeholder="Vælg produkt"
                                        [dropdown]="true"
                                        [forceSelection]="false"
                                        (completeMethod)="searchItemStocks($event)"
                                        (onSelect)="ItemSelected($event.value)"
                                        [style]="{ width: '100%' }"
                                        [inputStyle]="{ width: '100%' }">

                            <ng-template pTemplate="item" let-item>
                                {{ item.itemCode }} - {{ item.itemName }}
                            </ng-template>

                            <ng-template pTemplate="selectedItem" let-item>
                                {{ item.itemCode }} - {{ item.itemName }}
                            </ng-template>
                        </p-autoComplete>

                        <!-- <p-dropdown [options]="itemStocks$ | async" (onChange)="ItemSelected($event.value)"
                                    formControlName="catalogItem" optionLabel="itemName"
                                    placeholder="Vælg produkt">

                            <ng-template pTemplate="optionLabel" let-item>
                                {{item.itemCode}} - {{item.itemName}}
                            </ng-template>
                        </p-dropdown> -->

                        <!-- <p-floatLabel variant="on">
                            <input pInputText #amount (change)="AutoMarkItemStocks(amount.value,dt1 ?? dt2)" />
                            <label for="amount">{{"WAREHOUSE.WAREHOUSEORDRE.AMOUNT" | translate}}</label>
                        </p-floatLabel> -->

                    </div>
                </div>
                <ng-template #placeholderText>
                    <div>{{"WAREHOUSE.WAREHOUSEORDRE.CARTPLACEHOLDER" |translate}}</div>
                </ng-template>
                <div>
                    <button *ngIf="!IsShowSelectedItems; else Baskect" pButton (click)="showSelectedItems()"> {{"WAREHOUSE.WAREHOUSEORDRE.AMOUNTPICKED" |translate}} - {{selectedProducts.length}} </button>
                    <ng-template #Baskect>
                        <button pButton (click)="showSelectedItems()"> {{"WAREHOUSE.WAREHOUSEORDRE.BASKET" |translate}} - {{selectedProducts.length}} </button>
                    </ng-template>
                </div>

            </div>

            <!-- Table from selection in items -->
            <div *ngIf="IsShowSelectedItems">

                <p-table #dt1 id="dt1" [value]="selectedProducts" [tableStyle]="{ 'min-width': '50rem' }" dataKey="id"
                         [(selection)]="selectedProducts">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.ITEMCODE" | translate}}</th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.NAME" | translate}}</th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.LOCATIONTYPE" | translate}}</th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.DESCRIPTION" | translate}}</th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.COLLITYPE" | translate}}</th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.AMOUNTONPALLET" | translate}}</th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.DATE" | translate}}</th>
                            <th>{{"WAREHOUSE.WAREHOUSEORDRE.STACKABLE" | translate}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item>
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="item" />
                            </td>
                            <td>{{item.itemCode}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.locationType}}</td>
                            <td>{{item.description}}</td>
                            <td>{{item.colliType}}</td>
                            <td>{{item.amountOnPallet}}</td>
                            <td>{{(item.dtm ?? RepalceNullDate()) | date : 'dd/MM/yyyy'}}</td>
                            <td><i *ngIf="item.stackable" class="pi pi-check"></i></td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>


            <p-table #dt2 *ngIf="!IsShowSelectedItems" [value]="itemStockDetails$ |async"
                     [(selection)]="selectedProducts" [tableStyle]="{ 'min-width': '50rem' }" dataKey="id"
                     selectionMode="multiple" [globalFilterFields]="['BatchNo']">

                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                        <th><p-columnFilter field="batchNo" [showClearButton]="false" /></th>
                        <th><p-columnFilter field="itemCode" [showClearButton]="false" /> </th>
                        <th><p-columnFilter field="name" [showClearButton]="true" /> </th>
                        <th><p-columnFilter field="description" [showClearButton]="false" /> </th>
                        <th><p-columnFilter field="colliType" [showClearButton]="false" /> </th>
                        <th><p-columnFilter type="date" field="date" [showClearButton]="false" /> </th>
                        <th></th>
                    </tr>
                    <tr>
                        <th style="width: 4rem"></th>
                        <th>{{"WAREHOUSE.WAREHOUSEORDRE.BATCHNO" | translate}}</th>
                        <th>{{"WAREHOUSE.WAREHOUSEORDRE.ITEMCODE" | translate}}</th>
                        <th>{{"WAREHOUSE.WAREHOUSEORDRE.NAME" | translate}}</th>
                        <th>{{"WAREHOUSE.WAREHOUSEORDRE.DESCRIPTION" | translate}}</th>
                        <th>{{"WAREHOUSE.WAREHOUSEORDRE.COLLITYPE" | translate}}</th>
                        <th>{{"WAREHOUSE.WAREHOUSEORDRE.AMOUNTONPALLET" | translate}}</th>
                        <th>{{"WAREHOUSE.WAREHOUSEORDRE.DATE" | translate}}</th>
                        <th pSortableColumn="stackable"> stackable</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item let-editing="editing">
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="item" />
                        </td>
                        <td>{{item.batchNo}}</td>
                        <td>{{item.itemCode}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.description}}</td>
                        <td>{{item.colliType}}</td>
                        <td [pEditableColumn]="item.changeAmountOnPallet">

                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <input pInputText type="text" [(ngModel)]="item.changeAmountOnPallet"
                                           [ngModelOptions]="{ standalone: true }"
                                           (blur)="CheckForMaxAmount(item, item.changeAmountOnPallet)"
                                           (keydown.enter)="CheckForMaxAmount(item, item.changeAmountOnPallet)" />
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{ item.changeAmountOnPallet }} / {{item.amountOnPallet}}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td>{{(item.dtm ?? RepalceNullDate()) | date : 'dd/MM/yyyy'}}</td>
                        <td><i *ngIf="item.stackable" class="pi pi-check"></i></td>
                    </tr>
                </ng-template>
            </p-table>

            <div>

            </div>
            <div class="flex pt-4 justify-content-end">
                <p-button [disabled]="selectedProducts.length <= 0" [label]="'WAREHOUSE.WAREHOUSEORDRE.NEXT' | translate" icon="pi pi-arrow-right"
                          iconPos="right" (onClick)="nextCallback.emit();" />
            </div>
        </ng-template>

    </p-stepperPanel>

    <p-stepperPanel [header]=" 'WAREHOUSE.WAREHOUSEORDRE.DEVLIVEYINFOMATION' | translate">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index"
                     let-nextCallback="nextCallback">
            <div
                 style="display: flex; flex-direction: column; flex-wrap: nowrap; justify-content: space-evenly; align-items: flex-start; gap: 15px;">
                <!-- date & ordrenumber & name -->
                <div style="display: flex; flex-direction: row; flex-wrap: nowrap; align-items: flex-end; justify-content: space-evenly; gap:15px">
                    <span style="display: flex; flex-direction: column; gap: 5px;">
                        <label for="deliveryDate">{{"WAREHOUSE.WAREHOUSEORDRE.deliveryDate" | translate}} </label>
                        <alice-dateSeletor #deliveryDate (DateChangeEvent)="DateChange($event)" [minDate]="minDate"></alice-dateSeletor>
                    </span>
                    <p-floatLabel>
                        <input pInputText #orderNumber formControlName="orderNumber" />
                        <label for="orderNumber"> {{"WAREHOUSE.WAREHOUSEORDRE.ORDERNUMBER" | translate}} / {{"WAREHOUSE.WAREHOUSEORDRE.REFERENCE" | translate}}</label>
                    </p-floatLabel>
                </div>

                <div>
                    <!-- notes -->
                    <p-floatLabel class="order-formfields-textare">
                        <textarea style="width: 33vw; height: 10vh;" #note pInputTextarea formControlName="note"></textarea>
                        <label for="note"> {{"WAREHOUSE.WAREHOUSEORDRE.REMARK" | translate}} </label>
                    </p-floatLabel>
                </div>
            </div>
            <div style="display: flex; flex-direction: row; justify-content: space-between; padding-top: 15px;">
                <p-button [label]="'WAREHOUSE.WAREHOUSEORDRE.BACK' | translate" icon="pi pi-arrow-left" (onClick)="prevCallback.emit()" />
                <p-button [label]="'WAREHOUSE.WAREHOUSEORDRE.NEXT' | translate" icon="pi pi-arrow-right" iconPos="right" (onClick)="nextCallback.emit()" />
            </div>
        </ng-template>
    </p-stepperPanel>

    <p-stepperPanel [header]=" 'WAREHOUSE.WAREHOUSEORDRE.RECEIVERINFOMATION' | translate">

        <ng-template pTemplate="content" let-nextCallback="nextCallback" let-prevCallback="prevCallback" let-index="index">

            <div style="display: flex; flex-direction: column; gap:26px">
                <!-- Søging -->
                <div>
                    <div style="padding-bottom: 5px;">
                        <p-divider>{{'WAREHOUSE.WAREHOUSEORDRE.SEARCHSECTIOR' | translate}}</p-divider>
                        <hr />
                    </div>
                    <div style="display: flex; flex-direction: row; gap:10px; flex-wrap: wrap;">
                        <p-floatLabel variant="on">
                            <p-autoComplete [suggestions]="foundCustomers" [minLength]="3" formControlName="customerObject"
                                            #name [delay]="500" inputId="name" autocomplete="anyrandomstring" showEmptyMessage="true"
                                            emptyMessage="{{'NORESULTS' | translate}}" (completeMethod)="searchCustomer($event)"
                                            showClear="true" optionLabel="name" (onClear)="ClearCustomerObject()"
                                            (onSelect)="setCustomer($event.value)">

                                <ng-template let-customer pTemplate="item">
                                    <div class="customer-item">
                                        <div>
                                            <p>{{customer.name}}</p>
                                            <span *ngIf="customer.address" class="grayedText">
                                                {{customer.address.street}}, {{customer.address.zipCode}},
                                                {{customer.address.city}}</span>
                                            <span *ngIf="customer.contactPerson" style="font-size:12px; color:gray;"> | {{'CUSTOMER.FORM.CONTACTPERSON' | translate}} {{customer.contactPerson.name}} <span *ngIf="customer.contactPerson.email">,
                                                    {{customer.contactPerson.email}}</span>
                                                <span *ngIf="customer.contactPerson.phone">,
                                                    {{customer.contactPerson.phone}}</span></span>
                                        </div>
                                    </div>
                                </ng-template>
                            </p-autoComplete>
                            <label for="name">{{'NAME' | translate}} {{'SEARCHFIELD' | translate}}</label>
                        </p-floatLabel>

                        <p-floatLabel variant="on">
                            <p-autoComplete [suggestions]="foundAddresses" [minLength]="3" [formControl]="adresseForm"
                                            name="addressField" [delay]="500" inputId="addressStreet" #addressStreet
                                            aria-autocomplete="none" autocomplete="anyrandomstring0"
                                            (completeMethod)="searchAddress($event)" (onSelect)="setAddress($event.value)"
                                            [field]="formattedStreetName">

                                <ng-template let-address pTemplate="item">
                                    <div class="address-item">
                                        <div>
                                            <img *ngIf="address.countryCode" src="assets/demo/flags/flag_placeholder.png"
                                                 [class]="'flag flag-' + address.countryCode.toLowerCase()" />
                                            {{address.street}},
                                            <span class="grayedText"> {{address.zipCode}} {{address.city}}</span>
                                        </div>
                                    </div>
                                </ng-template>
                            </p-autoComplete>
                            <label for="addressStreet">{{'ADDRESS' | translate}}</label>
                        </p-floatLabel>

                    </div>
                </div>
                <!-- addrese info -->
                <div>
                    <div style="padding-bottom: 5px;">

                        <p-divider>{{'WAREHOUSE.WAREHOUSEORDRE.ADDADDRESSSECTOR' | translate}}</p-divider>
                        <hr />
                    </div>
                    <div [formGroup]="SelectedAdresseObject" style="display: flex; flex-direction: column; gap:12px;">
                        <div style="display: flex; flex-direction: row; gap:12px;">
                            <p-floatLabel variant="on">
                                <input pInputText #zipCode formControlName="zipCode" />
                                <label for="zipCode">{{'WAREHOUSE.WAREHOUSEORDRE.ZIPCODE' | translate}}</label>
                            </p-floatLabel>
                            <p-floatLabel variant="on">
                                <input pInputText #city formControlName="city" />
                                <label for="city">{{'WAREHOUSE.WAREHOUSEORDRE.CITY' | translate}}</label>
                            </p-floatLabel>

                            <p-floatLabel variant="on">
                                <input pInputText #street formControlName="street" />
                                <label for="street">{{'WAREHOUSE.WAREHOUSEORDRE.STREET' | translate}}</label>
                            </p-floatLabel>

                        </div>

                    </div>
                </div>
                <!-- Contact info -->
                <div>
                    <div style="padding-bottom: 5px;">
                        <p-divider>{{'WAREHOUSE.WAREHOUSEORDRE.CONTACTSECTOR' | translate}}</p-divider>
                        <hr />
                    </div>
                    <div [formGroup]="deliveryInfomationFormGroup" style="display: flex; flex-direction: row; gap: 12px; width: 50%;">
                        <p-floatLabel variant="on">
                            <input formControlName="deliveryContactPhone" pInputText id="contactPhone" #contactPhone type="text" placeholder="{{'CONTACTPHONE' | translate}}" />
                            <label>{{'CONTACTPHONE' | translate}}</label>
                        </p-floatLabel>
                        <p-floatLabel variant="on">
                            <input formControlName="deliveryContactEmail" pInputText id="email" #contactPhone type="text" placeholder="{{'EMAIL' | translate}}" />
                            <label>{{'EMAIL' | translate}}</label>
                        </p-floatLabel>

                        <p-floatLabel variant="on">
                            <input pInputText #countryCode [formControl]="SelectedAdresseObject.get('countryCode')" />
                            <label for="countryCode">{{'WAREHOUSE.WAREHOUSEORDRE.COUNTRYCODE' | translate}}</label>
                        </p-floatLabel>

                        <p-floatLabel variant="on">
                            <input pInputText #deliveryContactPerson id="deliveryContactPerson" [formControl]=" deliveryInfomationFormGroup.get('deliveryContactPerson')" />
                            <label for="deliveryContactPerson">{{'WAREHOUSE.WAREHOUSEORDRE.CONTACT' | translate}}</label>
                        </p-floatLabel>

                        <!-- <p-floatLabel variant="on">
                        <input pInputText #DeliveryOrderNo formControlName="deliveryOrderNo" />
                        <label for="DeliveryOrderNo">leverings nummer</label>
                    </p-floatLabel>

                    <p-floatLabel variant="on">
                        <input pInputText #DeliveryNote formControlName="deliveryNote" />
                        <label for="DeliveryNote">leverings note</label>
                    </p-floatLabel> -->

                    </div>
                </div>
            </div>



            <div class="flex pt-4 justify-content-between">
                <p-button [label]="'WAREHOUSE.WAREHOUSEORDRE.BACK' | translate" icon="pi pi-arrow-left" (onClick)="prevCallback.emit()" />
                <p-button [label]="'WAREHOUSE.WAREHOUSEORDRE.NEXT' | translate" icon="pi pi-arrow-right" iconPos="right" [disabled]="SelectedAdresseObject.invalid || !orderForm.controls.customerObject.value" (onClick)="nextCallback.emit()">
                </p-button>

            </div>

        </ng-template>

    </p-stepperPanel>

    <p-stepperPanel [header]=" 'WAREHOUSE.WAREHOUSEORDRE.CONFOMATION' | translate" header="">
        <ng-template pTemplate="content" let-prevCallback="prevCallback" let-index="index">
            <div class="confirmation-content" style="display: flex; flex-direction: column; gap: 27px; padding: 16px;">
                <h3>{{'WAREHOUSE.WAREHOUSEORDRE.CONFOMATIONMESSAGE' | translate }}</h3>

                <div style="display: flex; flex-direction: row; justify-content: space-between;">

                    <!-- Customer Info -->
                    <div *ngIf="orderForm.get('customerObject')?.value">
                        <h4>{{'WAREHOUSE.WAREHOUSEORDRE.RECEIVERINFOMATION' | translate}}</h4>
                        <p>{{'WAREHOUSE.WAREHOUSEORDRE.NAME' | translate}}: {{ orderForm.get('customerObject')?.value?.name }}</p>
                        <p>{{'WAREHOUSE.WAREHOUSEORDRE.ADRESSE' | translate}}: {{ SelectedAdresseObject.value.street }}, {{ SelectedAdresseObject.value.zipCode }}
                            {{ SelectedAdresseObject.value.city }}</p>
                        <p>{{'WAREHOUSE.WAREHOUSEORDRE.COUNTRY' | translate}}: {{ SelectedAdresseObject.value.countryCode }}</p>
                    </div>

                    <!-- Delivery Info -->
                    <div *ngIf="deliveryInfomationFormGroup">
                        <h4>{{'WAREHOUSE.WAREHOUSEORDRE.DEVLIVEYINFOMATION' | translate}}</h4>
                        <p>{{'WAREHOUSE.WAREHOUSEORDRE.CONTACT' |translate}}: {{ deliveryInfomationFormGroup.value.deliveryContactPerson }}</p>
                        <p>{{'WAREHOUSE.WAREHOUSEORDRE.CONTACT' |translate}}: {{ deliveryInfomationFormGroup.value.deliveryContactPhone }} / {{
                            deliveryInfomationFormGroup.value.deliveryContactEmail }}</p>
                        <!-- <p>Leveringsnummer: {{ deliveryInfomationFormGroup.value.deliveryOrderNo }}</p> -->
                        <p>Noter: {{ deliveryInfomationFormGroup.value.deliveryNote }}</p>
                    </div>
                </div>

                <!-- Order Note -->
                <div *ngIf="orderForm.get('note')?.value">
                    <h4>{{'WAREHOUSE.WAREHOUSEORDRE.REMARK' | translate}}</h4>
                    <p>{{ orderForm.get('note')?.value }}</p>
                </div>

                <!-- Overview of selected products [activeIndex]="0"-->
                <p-accordion>
                    <p-accordionTab header="valgte vare">
                        <div>
                            <h4>{{'WAREHOUSE.WAREHOUSEORDRE.PCIKEDPRODUCTS' | translate}}</h4>
                            <ul>
                                <li *ngFor="let product of selectedProducts">
                                    {{ product.name }} ({{ product.itemCode }}) - {{ product.description }}
                                </li>
                            </ul>
                        </div>
                    </p-accordionTab>
                </p-accordion>

                <div class="flex justify-content-between pt-4">
                    <p-button [label]="'WAREHOUSE.WAREHOUSEORDRE.BACK' | translate" icon="pi pi-arrow-left" (onClick)="prevCallback.emit()" />
                    <p-button icon="pi pi-check" [label]="'WAREHOUSE.WAREHOUSEORDRE.CONFOMATIONBTNTEXT' | translate" class="p-button-success"
                              (onClick)="CreateOrderFromFormGroups()" />
                </div>
            </div>
        </ng-template>
    </p-stepperPanel>
</p-stepper>